/**
 * Display label and route for each followup onboarding step that can appear
 * in the CUBK contextual alert. The id matches the backend OnboardingStepId
 * enum value, and is the only piece the API returns — labels and routes are
 * presentation concerns owned by the web app.
 */
export const FOLLOWUP_ITEMS: Record<string, { label: string; route: string }> =
  {
    UPLOAD_BANK_STATEMENTS: {
      label: 'Fill in transaction gaps',
      route: '/practice/statements',
    },
    CLARIFY_UNCATEGORIZED_TRANSACTIONS: {
      label: 'Review unclear transactions',
      route: '/transactions/review',
    },
  }
